import { FREE_GIFT_IDS, PromoType } from '@/components/blocks/FreeGiftV2/constants';
import { useFreeGiftInteraction } from '@/components/blocks/FreeGiftV2/context/FreeGiftInteractionContext';
import { useFreeGiftPromotion } from '@/components/blocks/FreeGiftV2/context/FreeGiftPromotionContext';
import { PromotionDrawer } from '@/components/blocks/FreeGiftV2/parts/PromotionDrawer';
import { PromotionFooterSx } from '@/components/blocks/FreeGiftV2/styles/freeGift';
import DynamicIcon from '@/components/icons/DynamicIcon';
import { useLocalization } from '@/data/Localization';
import { Alert, Button, useTheme } from '@mui/material';
import { MATERIAL_SYMBOL_ICONS } from 'shared/custom/constants/commonConstants';

export const PromotionFooter = () => {
	const { isRewardView, handleOpenDrawer, isPromotionComplete, openDrawer, hasAddedToCart } =
		useFreeGiftInteraction();
	const { rewardsQty, reward, purchase, promotionGroups, selectedPromotionIndex, promoThdCode } =
		useFreeGiftPromotion();
	const isRewardCombinable = reward?.combinable;
	const isPurchaseCombinable = purchase?.combinable;
	const noPromotionSelected =
		promotionGroups.length > 1 && !promotionGroups[selectedPromotionIndex];
	const labels = useLocalization('FreeGift');
	const labelsReward = useLocalization('FreeReward');
	const theme = useTheme();

	const getButtonLabel = () => {
		if (isPromotionComplete) {
			return labels.EditSelection.t();
		}

		if (promoThdCode === PromoType.PG) {
			return labels.ChoseMyGift.t();
		}

		if (isRewardView) {
			if (noPromotionSelected || isPurchaseCombinable) {
				return labelsReward.SeeEligibleItems.t();
			}

			return rewardsQty > 1 ? labels.ChoseMyGifts.t() : labels.ChoseMyGift.t();
		}

		if (noPromotionSelected) {
			return labels.SeeAvailablePromotions.t();
		}

		if (!isRewardCombinable) {
			return labels.SeePromotion.t();
		}

		return rewardsQty > 1 ? labels.ChoseMyGifts.t() : labels.ChoseMyGift.t();
	};

	return (
		<>
			<Button
				variant="outlined"
				color="primary"
				fullWidth
				disableRipple
				onClick={handleOpenDrawer}
				sx={PromotionFooterSx.button}
				id={isPromotionComplete ? FREE_GIFT_IDS.ctaEditDrawer : FREE_GIFT_IDS.ctaOpenDrawer}
			>
				{getButtonLabel()}
			</Button>
			{hasAddedToCart ? (
				<Alert
					severity="success"
					icon={
						<DynamicIcon
							name={MATERIAL_SYMBOL_ICONS.check}
							color={theme.palette.success.dark}
							size="24px"
						/>
					}
					sx={PromotionFooterSx.successAlert}
				>
					{labels.PromotionAddedToCart.t()}
				</Alert>
			) : isPromotionComplete && !openDrawer ? (
				<Alert
					icon={
						<DynamicIcon
							name={MATERIAL_SYMBOL_ICONS.awardStar}
							color={theme.palette.grey[300]}
							size="24px"
						/>
					}
					severity="info"
					sx={PromotionFooterSx.infoAlert}
				>
					{labels.AddToCartGiftsReminder.t()}
				</Alert>
			) : null}
			<PromotionDrawer />
		</>
	);
};
